"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
const extendTheme_1 = require("../extendTheme");
const lifeCycle_1 = require("../lifeCycle");
exports.theme = extendTheme_1.extendTheme(lifeCycle_1.theme, {
    name: 'christmas',
    userFriendlyName: 'Christmas',
    fontImports: [
        "@import url('https://fonts.googleapis.com/css?family=Roboto:300,400,700,900')",
        "@import url('https://fonts.googleapis.com/css2?family=Arvo&display=swap')",
        "@import url('https://fonts.googleapis.com/css2?family=Arvo&family=Mountains+of+Christmas:wght@400;700&display=swap')",
    ],
    colors: {
        primary: '#a41000',
        primaryDark: '#960000',
        primaryText: '#fff',
        accent: '#FCB600',
        pageBackground: '#d48080',
        cardBackground: '#f6f0f0',
        cardText: '#000',
        pageText: '#fff',
    },
    fonts: {
        heading: 'Mountains of Christmas',
        subheading: 'Mountains of Christmas',
        body: 'Arvo',
        navigation: 'Mountains of Christmas',
    },
});
//# sourceMappingURL=index.js.map